import { v4 as uuidv4 } from 'uuid';

const STORAGE_PREFIX = 'twilio-participant:';

const getBrowserStorage = name =>
  typeof window === 'undefined' ? null : window[name];

export const getTwilioParticipantStorageKey = sessionId =>
  `${STORAGE_PREFIX}${sessionId}`;

export const replaceTwilioParticipantIdentity = (
  sessionId,
  {
    storage = getBrowserStorage('sessionStorage'),
    createId = uuidv4,
  } = {}
) => {
  const participantId = String(createId());

  if (sessionId) {
    storage?.setItem(getTwilioParticipantStorageKey(sessionId), participantId);
  }

  return participantId;
};

export const getOrCreateTwilioParticipantIdentity = (
  sessionId,
  {
    storage = getBrowserStorage('sessionStorage'),
    legacyStorage = getBrowserStorage('localStorage'),
    createId = uuidv4,
  } = {}
) => {
  if (!sessionId) return '';

  const storageKey = getTwilioParticipantStorageKey(sessionId);
  const participantId = storage?.getItem(storageKey);

  if (participantId) return participantId;

  const nextParticipantId = replaceTwilioParticipantIdentity(sessionId, {
    storage,
    createId,
  });
  legacyStorage?.removeItem(String(sessionId));

  return nextParticipantId;
};

export const clearTwilioParticipantIdentity = (
  sessionId,
  {
    storage = getBrowserStorage('sessionStorage'),
    legacyStorage = getBrowserStorage('localStorage'),
  } = {}
) => {
  if (!sessionId) return;

  storage?.removeItem(getTwilioParticipantStorageKey(sessionId));
  legacyStorage?.removeItem(String(sessionId));
};
